module.exports = __webpack_public_path__ + "media/src/assets/Images/CarouselMain-c646a694f1a8a9992a00c582fd12c769.jpg";